// extracted by mini-css-extract-plugin
export default {"transcript":"OverlayBotChat_transcript__NnwBX"};